var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel-content" }, [
    _c(
      "div",
      {
        staticStyle: {
          "background-color": "#F5F5F5",
          "padding-left": "10px",
          "padding-right": "10px",
          "padding-bottom": "10px",
          "padding-top": "10px",
        },
      },
      [
        _c("div", { staticClass: "hotel-list listing-style3 hotel" }, [
          _c("div", { staticClass: "hot-deals-list" }, [
            _c(
              "div",
              {
                staticClass:
                  "row hotel-list image-box hotel listing-style1 add-clearfix",
              },
              [
                _c("div", { staticClass: "col-md-12" }, [
                  _c(
                    "article",
                    {
                      staticClass: "box",
                      class: {
                        "has-discount": _vm.getBookingCartIsSrvcAlreadyInCart({
                          id_pax: _vm.id_pax,
                          srvcs: _vm.srvcs,
                        }),
                      },
                    },
                    [
                      _c("figure", [
                        _c("a", { staticClass: "hover-effect" }, [
                          _c("img", {
                            attrs: {
                              width: "200",
                              height: "50",
                              alt: "",
                              src: _vm.srvcs_image,
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.getBookingCartIsSrvcAlreadyInCart({
                                    id_pax: _vm.id_pax,
                                    srvcs: _vm.srvcs,
                                  }),
                                  expression:
                                    "getBookingCartIsSrvcAlreadyInCart({ id_pax: id_pax, srvcs: srvcs })",
                                },
                              ],
                              staticClass: "discount",
                            },
                            [
                              _c("span", { staticClass: "discount-text" }, [
                                _vm._v(_vm._s(_vm.added[_vm.getCurrentLocale])),
                              ]),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "details col-sm-12 col-md-12" },
                        [
                          _c("div", [
                            _c("div", [
                              _c("h4", { staticClass: "box-title" }, [
                                _vm._v(
                                  "\n                                            " +
                                    _vm._s(_vm.srvcs.description) +
                                    "\n                                            "
                                ),
                                _c("small", [
                                  _c("i", {
                                    staticClass:
                                      "soap-icon-departure yellow-color",
                                  }),
                                  _vm._v(
                                    "\n                                                " +
                                      _vm._s(_vm.srvcs.code) +
                                      "\n                                            "
                                  ),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _c("div", { staticClass: "amenities" }, [
                                _c("i", {
                                  class: _vm.soap_icon,
                                  staticStyle: { color: "#9e4d84" },
                                }),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "second-row" }, [
                            _c("div", [
                              _vm.srvcs.acceptComment === true &&
                              _vm.srvcs_type === "PETS"
                                ? _c("span", [
                                    _c("br"),
                                    _vm._v(" "),
                                    _c("h4", { staticClass: "box-title" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.comment[_vm.getCurrentLocale]
                                        ) + ":"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-group row pet-comment-field",
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "col-md-10" },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "skin-color pet-comment-label",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.petCommentBoxDimensions[
                                                      _vm.getCurrentLocale
                                                    ]
                                                  ) + ":"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("textarea", {
                                              ref: "inputService_comment_boxDimensions",
                                              staticClass: "full-width",
                                              attrs: { rows: "2" },
                                            }),
                                            _vm._v(" "),
                                            _vm.petCommentFieldErrors
                                              .boxDimensions
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "pet-comment-error",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm
                                                          .commentfieldisemptytext[
                                                          _vm.getCurrentLocale
                                                        ]
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-group row pet-comment-field",
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "col-md-10" },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "skin-color pet-comment-label",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.petCommentBoxWeight[
                                                      _vm.getCurrentLocale
                                                    ]
                                                  ) + ":"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("textarea", {
                                              ref: "inputService_comment_boxWeight",
                                              staticClass: "full-width",
                                              attrs: { rows: "2" },
                                            }),
                                            _vm._v(" "),
                                            _vm.petCommentFieldErrors.boxWeight
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "pet-comment-error",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm
                                                          .commentfieldisemptytext[
                                                          _vm.getCurrentLocale
                                                        ]
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-group row pet-comment-field",
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "col-md-10" },
                                          [
                                            _c(
                                              "label",
                                              {
                                                staticClass:
                                                  "skin-color pet-comment-label",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm
                                                      .petCommentBreedAnimalType[
                                                      _vm.getCurrentLocale
                                                    ]
                                                  ) + ":"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("textarea", {
                                              ref: "inputService_comment_breedAnimalType",
                                              staticClass: "full-width",
                                              attrs: { rows: "2" },
                                            }),
                                            _vm._v(" "),
                                            _vm.petCommentFieldErrors
                                              .breedAnimalType
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "pet-comment-error",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm
                                                          .commentfieldisemptytext[
                                                          _vm.getCurrentLocale
                                                        ]
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm.srvcs.acceptComment === true
                                ? _c("span", [
                                    _c("br"),
                                    _vm._v(" "),
                                    _c("h4", { staticClass: "box-title" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.comment[_vm.getCurrentLocale]
                                        ) + ":"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "form-group row" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "col-md-10" },
                                          [
                                            _c("textarea", {
                                              ref: "inputService_comment",
                                              staticClass: "full-width",
                                              attrs: { rows: "3" },
                                            }),
                                            _vm._v(" "),
                                            _vm.commentFieldIsEmpty
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "red",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm
                                                          .commentfieldisemptytext[
                                                          _vm.getCurrentLocale
                                                        ]
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _vm.srvcs.remark !== ""
                                ? _c("h4", { staticClass: "box-title" }, [
                                    _vm._v(
                                      _vm._s(_vm.remark[_vm.getCurrentLocale]) +
                                        ":"
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c("p", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.srvcs.remark),
                                },
                              }),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "col-md-4",
                                  staticStyle: { "padding-left": "0px" },
                                },
                                [
                                  _c("div", { staticClass: "icon" }, [
                                    _c("i", {
                                      staticClass:
                                        "soap-icon-plus yellow-color",
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "skin-color" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.count[_vm.getCurrentLocale]
                                        ) + ":"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("br"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticStyle: { "padding-top": "4px" } },
                                    [
                                      _c("plusminsfield", {
                                        ref: "userInputSrvcsDetails_Count",
                                        attrs: {
                                          value: 1,
                                          min: 1,
                                          max: _vm.srvcs.maxBookablePax,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "col-md-8 ipadKorrektur",
                                  staticStyle: { "padding-left": "0px" },
                                },
                                [
                                  _c("div", { staticClass: "icon" }, [
                                    _c("i", {
                                      staticClass:
                                        "soap-icon-status yellow-color",
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "skin-color" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.servicebookingfor[
                                            _vm.getCurrentLocale
                                          ]
                                        ) + ":"
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("br"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticStyle: { "padding-top": "4px" } },
                                    [
                                      _vm.getDoesSrvcsExistOnOutOrRet(
                                        "out",
                                        _vm.srvcs.code
                                      )
                                        ? _c("toggle-button", {
                                            ref: "userInputSrvcsDetails_ToggleOut",
                                            attrs: {
                                              value: true,
                                              labels: {
                                                checked:
                                                  _vm.outward[
                                                    _vm.getCurrentLocale
                                                  ],
                                                unchecked:
                                                  _vm.no[_vm.getCurrentLocale],
                                              },
                                              color: {
                                                checked: "#A2CB5A",
                                                unchecked: "#D9D9D8",
                                              },
                                              width: "85",
                                              height: "30",
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.getDoesSrvcsExistOnOutOrRet(
                                        "out",
                                        _vm.srvcs.code
                                      )
                                        ? _c("toggle-button", {
                                            ref: "userInputSrvcsDetails_ToggleOut",
                                            attrs: {
                                              value: false,
                                              labels: {
                                                checked:
                                                  _vm.outward[
                                                    _vm.getCurrentLocale
                                                  ],
                                                unchecked:
                                                  _vm.no[_vm.getCurrentLocale],
                                              },
                                              color: {
                                                checked: "#A2CB5A",
                                                unchecked: "#D9D9D8",
                                              },
                                              width: "85",
                                              height: "30",
                                              disabled: "",
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.getDoesSrvcsExistOnOutOrRet(
                                        "ret",
                                        _vm.srvcs.code
                                      )
                                        ? _c("toggle-button", {
                                            ref: "userInputSrvcsDetails_ToggleRet",
                                            attrs: {
                                              value: true,
                                              labels: {
                                                checked:
                                                  _vm.returnflight[
                                                    _vm.getCurrentLocale
                                                  ],
                                                unchecked:
                                                  _vm.no[_vm.getCurrentLocale],
                                              },
                                              color: {
                                                checked: "#A2CB5A",
                                                unchecked: "#D9D9D8",
                                              },
                                              width: "85",
                                              height: "30",
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.getDoesSrvcsExistOnOutOrRet(
                                        "ret",
                                        _vm.srvcs.code
                                      )
                                        ? _c("toggle-button", {
                                            ref: "userInputSrvcsDetails_ToggleRet",
                                            attrs: {
                                              value: false,
                                              labels: {
                                                checked:
                                                  _vm.returnflight[
                                                    _vm.getCurrentLocale
                                                  ],
                                                unchecked:
                                                  _vm.no[_vm.getCurrentLocale],
                                              },
                                              color: {
                                                checked: "#A2CB5A",
                                                unchecked: "#D9D9D8",
                                              },
                                              width: "85",
                                              height: "30",
                                              disabled: "",
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _c("span", { staticClass: "price" }, [
                                _c("small", [
                                  _vm._v(
                                    "a/" +
                                      _vm._s(_vm.perleg[_vm.getCurrentLocale])
                                  ),
                                ]),
                                _vm._v(
                                  "\n                                            " +
                                    _vm._s(
                                      _vm._f("rndAmntRUAFWZ")(_vm.srvcs.price)
                                    ) +
                                    "\n                                        "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "button btn-small full-width text-center green",
                                  attrs: { title: "" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      _vm.srvcsSelected({
                                        id_pax: _vm.id_pax,
                                        srvcs: _vm.srvcs,
                                      })
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.btn_addservices[_vm.getCurrentLocale]
                                    )
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }